import {Component, OnInit} from '@angular/core';
import {optimistic} from "../../api/common-http.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthManagerService} from "../auth-manager.service";
import {PasswordsApiService} from "../../api/passwords-api.service";
import {flatMap} from "rxjs/internal/operators";
import {confirmPasswordValidator, passwordValidator, requiredFieldValidator} from "../../utils/validation/validators";

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {

  readonly form: FormGroup;

  showErrors: boolean = false;
  isFetching: boolean = true;
  token: string;

  constructor(
    private route: ActivatedRoute,
    private auth: AuthManagerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private passwordsApi: PasswordsApiService
  ) {
    this.route.queryParams.pipe(
      flatMap(params => {
        this.token = params['token'];
        return this.auth.checkAndApplyToken(this.token);
      })
    ).subscribe(valid => {
      if (valid) {
        this.isFetching = false;
      } else {
        console.log("password.reset.invalid");
        this.router.navigate(['/home']);
      }
    });

    this.form = formBuilder.group({
      password: ['', [requiredFieldValidator(), passwordValidator]
      ],
      confirmPassword: ['']
    }, {
      validator: confirmPasswordValidator
    })
  }

  ngOnInit(): void {
  }

  submit() {
    if (this.form.valid) {
      this.passwordsApi.reset(this.form.value.password).pipe(optimistic).subscribe(
        () => {
          console.log("password.reset.success");
          this.router.navigate(['/home']);
        }
      )
    } else {
      this.showErrors = true;
    }
  }
}
